// extracted by mini-css-extract-plugin
module.exports = {"c-activation-page":"ActivationPage_c-activation-page__m1nU_"};